// extracted by mini-css-extract-plugin
module.exports = {"container":"slider__container--1YYgj","knob":"slider__knob--40GTV","innerknob":"slider__innerknob--3QNnb"};